export default {
  "pages.report-lists.quest-group-daily-statistics.statisticsTime": "统计时间",
  "pages.report-lists.quest-group-daily-statistics.questType": "任务类型",
  "pages.report-lists.quest-group-daily-statistics.questType.tooltip": "任务类型说明：指后台配置的所有任务名字；",
  "pages.report-lists.quest-group-daily-statistics.questType.placeholder": "请选择任务类型",
  "pages.report-lists.quest-group-daily-statistics.promotionActiveNum": "参与任务人数",
  "pages.report-lists.quest-group-daily-statistics.promotionActiveNum.tooltip": "参与任务人数说明：指点击查看任务既为参与累计总人数；",
  "pages.report-lists.quest-group-daily-statistics.claimRewardNum": "获得奖励人数",
  "pages.report-lists.quest-group-daily-statistics.claimRewardNum.tooltip": "获得奖励人数说明：指获得当前任务奖励人数累计；",
  "pages.report-lists.quest-group-daily-statistics.completeNum": "完成任务人数",
  "pages.report-lists.quest-group-daily-statistics.completeNum.tooltip": "完成任务人数说明：指完成当前任务人数累计；",
  "pages.report-lists.quest-group-daily-statistics.claimRewardRatio": "获奖率",
  "pages.report-lists.quest-group-daily-statistics.claimRewardRatio.tooltip": "获奖率说明：指获奖率=获得奖励总人数/参与活动总人数*100%",
  "pages.report-lists.quest-group-daily-statistics.completeRatio": "完成率",
  "pages.report-lists.quest-group-daily-statistics.completeRatio.tooltip": "完成率说明：指完成率=完成任务总数/参与任务总数*100%；",
  "pages.report-lists.quest-group-daily-statistics.totalGemReward": "总奖励宝石",
  "pages.report-lists.quest-group-daily-statistics.totalGemReward.tooltip": "总奖励宝石说明：指所有用户通过完成任何一条任务获得的宝石累计（包括已领取+未领取）；",
  "pages.report-lists.quest-group-daily-statistics.claimedGemReward": "已领取宝石",
  "pages.report-lists.quest-group-daily-statistics.unclaimedGemReward": "未领取宝石",
  "pages.report-lists.quest-group-daily-statistics.totalCashReward": "总奖励金额",
  "pages.report-lists.quest-group-daily-statistics.totalCashReward.tooltip": "总奖励金额说明：指所有用户通过完成任何一条任务获得的奖金累计（包括已领取+未领取）；",
  "pages.report-lists.quest-group-daily-statistics.claimedCashReward": "已领取金额",
  "pages.report-lists.quest-group-daily-statistics.unclaimedCashReward": "未领取金额",
};
